import { CubeRequestConfig } from '../../../common/interface/cube-request-config.interface';

export interface GetSelfSentimentReportRequestDto {
  params: {
    reportType: string;
    date: string;
  };
  config: CubeRequestConfig;
}
